module.exports = __webpack_public_path__ + "static/cristal-74719923d5c01fce903cfcd3a2f8bf77.gif";